export default __webpack_public_path__ + "static/media/back-white.d56482c6.svg";